export default {
  assets: [],
  rootAssetId: undefined,
  musicAssetId: undefined,
  parent: undefined,
  parentIsEncrypt: false,
  parentSource: 0,
  total: 0,
  sort: "isLeaf",
  order: "ascending",
};
